import React, { useState, useEffect } from 'react';
import {
    IonHeader, IonIcon, IonModal, IonContent, IonText, IonInput, IonItem,
    IonCheckbox, IonRow, IonFooter
} from '@ionic/react';

import './MopHeaderMenusModal.scss';
import { useHistory } from "react-router-dom";
import '../theme/common.scss';
import { InputChangeEventDetail } from '@ionic/core';
import { bindActionCreators } from 'redux';
import * as ColleaguesStore from '../store/ColleagueStore';
import { ApplicationState } from '../store';
import { connect, useDispatch } from 'react-redux';
import { chevronBack } from 'ionicons/icons';
import * as basketActions from '../store/BasketStore';
import Button from '../components/Button';

interface LoginModalProps {
    isModalOpen: boolean;
    parentModalClick: () => void;
    closeModalClick: () => void;
    message: string | null | undefined;
    error: string | null | undefined;
    isLoggedIn: boolean;
}

const LoginModal: React.FC<LoginModalProps> = ({
    isModalOpen,
    parentModalClick,
    closeModalClick,
    error,
    isLoggedIn
}) => {
    const validatePin = bindActionCreators(ColleaguesStore.actionCreators.validatePin, useDispatch());

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [getConfirmPinErrorMessage, setConfirmPinErrorMessage] = useState<string>('')
    const [pinConfirmed, setPinConfirmed] = useState<boolean>(false);
    const [pin, setPin] = useState<string>('');
    const clearBasket = bindActionCreators(basketActions.actionCreators.clearBasketItems, useDispatch());

    const history = useHistory();

    const handleTextClick = () => {
        setPinConfirmed(!pinConfirmed);
    };

    const handlePinChange = (event: CustomEvent<InputChangeEventDetail>) => {
        const input = event.target as HTMLInputElement;
        const inputValue = input.value;

        setPin(inputValue);
    };

    const handleCheckboxChange = (event: CustomEvent) => {
        const checkbox = event.target as HTMLIonCheckboxElement;
        setPinConfirmed(checkbox.checked);
    };

    const handleSubmit = () => {
        if (pin.length === 0) {
            setErrorMessage("Enter a valid code.");
        } else if (pin.length < 4) {
            setErrorMessage("Please enter at least a 4 digit code.");
        } else {
            setErrorMessage("");

            if (pinConfirmed) {
                setConfirmPinErrorMessage("")
                validatePin(pin);
            } else {
                setConfirmPinErrorMessage("Please confirm that you agree with the statement above.");
            }
        }
    };

    useEffect(() => {
        if (isLoggedIn && isModalOpen) {
            closeModalClick()
            parentModalClick()
            clearBasket()
            history.push("/storesearch")
        }
    }, [isLoggedIn]);

    return (
        <>
            <IonModal
                isOpen={isModalOpen}
                onDidDismiss={closeModalClick}
                cssClass='AppHeaderBurgerMenu login-modal'
                swipeToClose={true}
            >
                <IonHeader className="ion-no-border modal-header" mode="md" onClick={closeModalClick}>
                    <div className="BackArrowWrapper">
                        <IonIcon icon={chevronBack} slot={"start"} class="BackArrow"></IonIcon>
                    </div>
                </IonHeader>
                <IonContent>
                    <IonText>
                        <h2>Log in to Colleague Area Access</h2>
                    </IonText>
                    <IonText>
                        <h4>Colleague Area Access code*</h4>
                    </IonText>
                    <IonItem>
                        <IonInput
                            type="password"
                            inputmode="text"
                            maxlength={10}
                            minlength={4}
                            value={pin}
                            onIonChange={handlePinChange}
                        />
                    </IonItem>
                    {(errorMessage || error) &&
                        <IonText>
                            <p className="login-modal-error">{errorMessage || (!pinConfirmed && !error?.startsWith("I") && error) || (pinConfirmed && error)}</p>
                        </IonText>
                    }
                    <IonRow className="ion-align-items-center ion-nowrap">
                        <IonCheckbox checked={pinConfirmed} onIonChange={handleCheckboxChange} className={pinConfirmed ? 'checked-checkbox' : 'unchecked-checkbox'}/>
                        <IonText onClick={() => handleTextClick()}>
                            <p className="login-modal-confirm-message">I confirm I am a Morrisons employee and currently working a shift in store</p>
                        </IonText>
                    </IonRow>
                    {getConfirmPinErrorMessage && !pinConfirmed &&
                    <IonText>
                        <p className="login-modal-error">{getConfirmPinErrorMessage}</p>
                    </IonText>
                    }
                </IonContent>
                <IonFooter>
                    <Button
                        onClick={handleSubmit}
                        expand="block"
                        color="secondary"
                        size="small"
                        rounded
                    >
                        Confirm
                    </Button>
                </IonFooter>
            </IonModal>
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    loading: state.colleague?.loading,
    error: state.colleague?.error,
    message: state.colleague?.message,
    isLoggedIn: state.colleague?.isLoggedIn ?? false
});

export default connect(mapStateToProps)(LoginModal);
